import React, {useId, useMemo} from 'react'
import {Box, useBreakpointValue, Flex} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import Slider from '../../components/cms/slider'
import ModuleContainer from '../../components/cms/module-container'
import Teaser from '../../components/cms/teaser'
import Heading from '../../components/cms/heading'
import Copy from '../../components/cms/copy'
import {hasValidString, parseAspectRatio} from '../../utils/utils'

function Carousel({
    moduleId,
    moduleType,
    pageId,
    headingLevel,
    aspectRatio,
    heading,
    copy,
    tiles,
    anchor,
    background,
    spacing
}) {
    const sliderId = useId()
    const ariaLabel = useMemo(
        () =>
            [
                hasValidString(heading.subline) && `${heading.subline} -`,
                heading.headline1,
                heading.headline2
            ]
                .filter(hasValidString)
                .join(' '),
        [heading.subline, heading.headline1, heading.headline2]
    )

    return (
        <ModuleContainer
            moduleId={moduleId}
            moduleType={moduleType}
            pageId={pageId}
            anchor={anchor}
            background={background}
            spacing={spacing}
            display="flex"
            flexDirection="column"
            align={'start'}
            heading={heading}
        >
            <Flex gap="spacing-16" flexDirection="column" textAlign={{base: 'left', s: 'center'}}>
                <Heading {...heading} headingLevel={headingLevel} alignment="inherit"></Heading>

                <Copy {...copy} alignment="inherit" />
            </Flex>

            <Box pt={{base: 'spacing-40', s: 'spacing-80'}}>
                <Slider
                    itemsPerSlide={useBreakpointValue({base: 1, s: 3})}
                    gap={4}
                    sliderLabel={ariaLabel}
                    sliderId={sliderId}
                    variant="carousel"
                >
                    {tiles.map((item, index) => (
                        <Box key={index}>
                            <Teaser
                                teaserBackground={false}
                                headline={item.headline}
                                headlineId={sliderId + '-headline-' + index}
                                hideHeadline={item.hideHeadline}
                                asset={item.asset}
                                assetFlip={item.assetFlip}
                                aspectRatio={parseAspectRatio(aspectRatio)}
                                copy={item.copy}
                                cta={item.cta}
                                widths={{base: '100vw', s: '430px', m: '480px', l: '640px'}}
                            ></Teaser>
                        </Box>
                    ))}
                </Slider>
            </Box>
        </ModuleContainer>
    )
}

Carousel.propTypes = {
    headingLevel: PropTypes.number,
    aspectRatio: PropTypes.string,
    heading: PropTypes.object,
    hideHeadline: PropTypes.bool,
    copy: PropTypes.object,
    tiles: PropTypes.array,
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    anchor: PropTypes.string,
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string,
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom'])
}

export default Carousel
